export const MINIMUM_USER_LICENCES = 1;

export const MINIMUM_DEVICE_LICENCES = 0;
